var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.227 10.504l.966.99c.41.42.41 1.099 0 1.514l-8.453 8.677c-.41.42-1.07.42-1.475 0l-8.458-8.677a1.086 1.086 0 010-1.514l.966-.99a1.026 1.026 0 011.492.017l4.995 5.38V3.07c0-.593.465-1.071 1.044-1.071h1.392c.579 0 1.044.478 1.044 1.071V15.9l4.995-5.38a1.02 1.02 0 011.492-.017z"
  }))));
}

export default SvgArrowDown;